import { render, staticRenderFns } from "./UserDeletionForm.vue?vue&type=template&id=135d37ca&scoped=true"
import script from "./UserDeletionForm.vue?vue&type=script&lang=js"
export * from "./UserDeletionForm.vue?vue&type=script&lang=js"
import style0 from "./UserDeletionForm.vue?vue&type=style&index=0&id=135d37ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135d37ca",
  null
  
)

export default component.exports